module.exports = __webpack_public_path__ + "static/benef1_rose-2b0be22e7352e9246cdb891903097381.jpg";